<template>
    <div class="stage-quote-wrap" :style="{ backgroundColor: color }">
        <div class="stage-quote-img-wrap" :style="{ backgroundColor: color }">
            <img class="stage-quote-img" :src="imgSrc" alt=""/>
        </div>
        <blockquote class="stage-quote" :class="'lines-' + lineCount">
            <div class="stage-quote-text text-uppercase knockout-full" v-html="stageQuote" ref="quoteText"></div>
            <div class="stage-quote-author knockout-junior"><span>&mdash;</span><span v-html="author"></span></div>
        </blockquote>
        <div class="stage-quote-logo"><img :src="logoSrc" alt=""/></div>
    </div>
</template>

<script>
    import {bus} from './../consts'

    export default {
        name: 'StageQuote',
        props: [
            'article',
            'quote',
            'index'
        ],
        data() {
            return {
                stageQuote: this.quote.stageQuote.text,
                author: this.quote.stageQuote.author,
                color: this.quote.color,
                accentColor: this.quote.stageQuote.accentColor,
                height: null,
                lineH: null
            }
        },
        computed: {
            imgSrc() {
                return require('./../assets/images/article_' + this.article.number + '/stage_quotes/' + this.quote.stageQuote.image)
            },
            logoSrc() {
                return require('./../assets/images/logos/'+ this.quote.stageQuote.logo + '-white.svg')
            },
            lineCount() {
                return this.height / this.lineH
            }
        },
        mounted() {
          if (!this.$store.state.isPortrait) {
            let accentText = this.$refs.quoteText.querySelectorAll('span')[0];
            if (typeof accentText !== 'undefined') {
                accentText.style.color = this.accentColor;
                accentText.style.color = this.accentColor;
            }

            setTimeout(() => {
              this.$el.classList.add('animate')
            }, 150)
          }

          this.height = this.$refs.quoteText.firstChild.clientHeight
          this.lineH = parseInt(window.getComputedStyle(this.$refs.quoteText.firstChild).getPropertyValue('line-height'));
          let accentText = this.$refs.quoteText.firstChild.getElementsByTagName('span')[0];
          if (typeof accentText !== 'undefined') {
              this.$refs.quoteText.firstChild.getElementsByTagName('span')[0].style.color = this.accentColor;
          }

          // bus.$emit('movePortraitUp')
        },
        beforeDestroy() {
          // bus.$emit('movePortraitDown')
        }
    }
</script>

<style lang="scss">
   @import '../scss/the-goods';

   .stage-quote {
      color     : rgba(255, 255, 255, 0.77);
      max-width : 80%;
      top       : 50%;
      transform : translateY(-50%);
      position  : relative;
      text-align: left;

       .landscape-mode & {
           @include screen-xs-sm {
               transform : none;
               top       : auto;
               bottom    : 0;
               position  : absolute;

               &.lines-5, &.lines-6 {
                   transform : 0;
               }
           }
       }

       @include screen-xxl {
           max-width: 90%;
       }

       @include screen-mobile {
           &.lines-5 {
               transform : translateY(-60%);
           }

           &.lines-6 {
               transform : translateY(-70%);
           }
       }

      &-wrap {
         position   : absolute;
         height     : 100%;
         width      : 100%;
         z-index    : 2;
         background : blue;
         top        : 0;
         left       : 0;
         padding    : 35% 10% 0 16%;
         transition : transform 500ms $default-bez;

         .portrait-mode & {
             opacity: 0;
             padding    : 35% 10% 0 8%;
             background-color: transparent
         }

         &.animate {
           .stage-quote-img-wrap img {
             transform : translateX(0%);
           }

           .stage-quote-text p,
           .stage-quote-author span,
           .stage-quote-logo img {
             transform : translateY(0%);
           }
         }
      }

      &-img-wrap {
         position : absolute;
         top      : 11%;
         right    : 8%;
         overflow : hidden;

          @include screen-mobile {
              top: 10%;
              right: 7%;
              max-width: 70%;
              height: auto;
          }

          @include screen-xxl {
              top: 18%;
              right: 10%;
          }

         img {
            // mix-blend-mode : multiply;
            opacity        : 0.85;
            transform      : translateX(100%);
            transition     : transform $default-bez .5s;
            max-width: 100%;
         }
      }

      &-text,
      &-author {
        overflow : hidden;

        p, span {
          transform        : translateY(40px);
          transition       : transform $default-bez .5s;
          transition-delay : 100ms;

          .landscape-mode & {
             @include screen-xs-sm {
                transform : translateY(170%);
             }
          }

          .portrait-mode & {
             @include screen-xs-sm {
                transition       : transform $default-bez 550ms;
                transition-delay : 50ms;
             }
          }

          span {
            transform: none;
          }
        }

        span {
          //transition-delay : 500ms;
        }

          @include screen-xs-sm {
              overflow: visible;
          }
      }

       &-text {
           p {
               font-size   : 6rem;
               line-height : 1.07;
               margin      : 0;
               margin-left: 24px;

               &:before {
                   content     : "\201C";
                   position    : absolute;
                   margin-left : -24px;
                   font-family : $KnockoutFull;

               }

               .landscape-mode & {
                   @include screen-xs-sm {
                       font-size      : 2.8rem;
                       letter-spacing : 0.14rem;
                   }
               }

               @include screen-xs-sm {
                   font-size   : 3.2rem;
                   letter-spacing: 0.2rem;
                   margin-left : 15px;
                   &:before {
                       margin-left : -15px;
                   }
               }

               @include screen-md-lg {
                   font-size: 4.5rem;
                   margin-left: 24px;

                   &:before {
                       margin-left : -24px;
                   }
               }

               @include screen-xxl {
                   font-size : 7rem;
               }
           }
       }

       &-author {
           margin-left : 24px;
           @include screen-xs-sm {
               margin-left : 15px;

           }

           @include screen-md-lg {
               &:before {
                   margin-left : -24px;
               }
           }

         span {
            font-size  : 2.5rem;
            margin-top : 1rem;
            display    : inline-block;

             @include screen-xs-sm {
                 font-size: 1.8rem;
                 letter-spacing: 0.1rem;
             }

             @include screen-md-lg {
                 font-size: 2rem;
             }


             @include screen-xxl {
                 font-size : 3rem;
             }
         }
      }

      &-logo {
         position : absolute;
         bottom   : 7%;
         right    : 7%;
         width    : 150px;
         height   : 60px;
         overflow : hidden;

          .portrait-mode & {
              bottom: auto;
              top: 8%;
              right: 9%;
          }

          .landscape-mode & {
              @include screen-xs-sm {
                  width  : 120px;
                  height : 60px;
                  right  : 4%;
                  top    : 2%;
                  bottom : auto;
              }
          }

          @include screen-xxl {
              width  : 180px;
              height : 90px;
          }

         img {
           object-fit       : contain;
           width            : 100%;
           height           : 100%;
           transform        : translateY(100%);
           transition       : transform $default-bez .5s;
           transition-delay : 100ms;
         }
      }
   }

   .portrait-mode {

       .stage-quote {

           &-img-wrap {
               @include screen-lg-xl {
                   width: 50%;
                   img {
                       width :100%;
                   }
               }
           }

           &-text {
               font-size : 5.5rem;

               @include screen-lg-xl {
                   p {
                       font-size :7rem;
                   }
               }
           }

           &-author {

               span {
                   @include screen-lg-xl {
                       font-size :3.2rem;
                   }
               }
           }

           &-logo {

               @include screen-xs-sm {
                   width: 95px;
                   height: 50px;
               }
               @include screen-lg-xl {
                   top: 4%;
                   right: -3%;
               }
           }

           &-wrap {
               @include screen-lg-xl {
                   width: 88%;
                   padding-left :4%;
               }
           }
       }

       .audio-player {
           @include screen-lg-xl {
               padding-right: 10%;
           }
       }

   }


</style>



// WEBPACK FOOTER //
// src/components/StageQuote.vue